// isNearBottom decides whether a chat transcript should auto-follow new content. Pure so the scroll
// decision is unit-tested without a layout engine (jsdom reports zeroed geometry).
export function isNearBottom(
  metrics: { scrollHeight: number; scrollTop: number; clientHeight: number },
  threshold = 100
): boolean {
  return metrics.scrollHeight - metrics.scrollTop - metrics.clientHeight < threshold
}
